import { toast } from "react-toastify";
import { setTitle } from "../../../../helpers/MetaTag";
import { handleFilterChange } from "../../../../helpers";
import DeleteModal from "../../../../components/common/DeleteModal";

import { useDebounce } from "../../../../hooks/useDebounce";
import LimitSelect from "../../../../components/elements/LimitSelect";
import { useState } from "react";
import Search from "../../../../components/form/Search";
import Table from "../../../../components/elements/table/Table";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Button from "../../../../components/form/Button";
import { eventDelete, eventList, eventOrdering, eventStatusChange } from "../../../../services/eventService";
import dayjs from "dayjs";
import ActionBar from "../../../../components/elements/ActionBar";
import { lngDetect } from "../../../../helpers/lngDetect";
import Badge from "../../../../components/elements/Badge";
import ManageEventDrawer from "../../../../components/sections/admin/Event/Drawer/ManageEventDrawer";
import Indentification from "../../../../components/elements/Indentification";
import { tableFilter } from "../../../../helpers/tableFilterOptions";

import { userList } from "../../../../services/userService";
import DatePicker from "../../../../components/form/DatePicker";

import EventDetailsDrawer from "../../../../components/sections/admin/Event/Drawer/EventDetailsDrawer";
import Select from "../../../../components/form/select/Select";
import { t } from "i18next";
import { organizationList } from "../../../../services/organizationService";

const Event = () => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [detailModal, setDetailModal] = useState({ isOpen: false, data: null });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [userkeyword, setuserKeyword] = useState("");
  const usersearch = useDebounce(userkeyword, 300);
  const orgsearch = useDebounce(userkeyword, 300);
  const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "ordering",
  });
  const [userfilters, setuserFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "ordering",
  });

  const [orgfilters, setOrgFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "ordering",
  });

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["Event", filters, search],
    queryFn: async () => {
      const res = await eventList({
        ...filters,
        ...(search && { keyword: search }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  const {
    data: userData,
    isFetching: userFetching,
    isLoading: userLoading,
    error: userError,
  } = useQuery({
    queryKey: ["user", usersearch, userfilters],
    queryFn: async () => {
      const queryParams = {
        ...userfilters,
        ...(usersearch && { keyword: usersearch }),
      };

      const res = await userList(queryParams);
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs || {};
    },
  });

  const {
    data: organizationData,
    isFetching: orgFetching,
    isLoading: orgLoading,
    error: orgError,
  } = useQuery({
    queryKey: ["organization", orgsearch, orgfilters],
    queryFn: async () => {
      const queryParams = {
        ...orgfilters,
        ...(orgsearch && { keyword: orgsearch }),
      };

      const res = await organizationList(queryParams);
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs || {};
    },
  });

  //   Event status change handler =================>
  const { mutate: statusChangeHandler, isPending: statusChangeInPending } = useMutation({
    mutationFn: async ({ id, status }) => {
      queryClient.setQueryData(["Event", filters, search], (state) => {
        if (state) {
          let stateData = JSON.parse(JSON.stringify(state?.data));
          stateData = (stateData || []).map((elm) =>
            elm?._id === id
              ? {
                  ...elm,
                  status: elm?.status === "active" ? "inactive" : "active",
                }
              : elm
          );
          return { ...state, data: stateData };
        }
      });
      const res = await eventStatusChange({
        ids: id,
        status: status,
      });
      return { res, payload: { id, status } };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status !== 200) {
        queryClient.setQueryData(["Event", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = (stateData || []).map((elm) =>
              elm?._id === payload?.id
                ? {
                    ...elm,
                    status: elm?.status === "active" ? "inactive" : "active",
                  }
                : elm
            );
            return { ...state, data: stateData };
          }
        });
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const tableHeadData = [
    {
      _id: 1,
      name: "Event",
      align: "left",
    },
    {
      _id: "CreatedBy",
      name: "Created By",
      align: "left",
      ...tableFilter({
        filterKey: "user",
        filters,
        setFilters: (val) => {
          setFilters((pre) => ({ ...pre, ...val }));
        },
        filterList: userData?.data?.map((item) => ({
          name: `${item?.firstName} ${item?.lastName}`,
          value: item?._id,
          type: "checkbox",
        })),
      }),
    },
    {
      _id: "eventStart",
      name: "Start Date",
      align: "left",
      ...tableFilter({
        content: (
          <DatePicker
            range
            onChange={({ startDate, endDate }) => {
              if (!startDate && !endDate) {
                setFilters((pre) => {
                  delete pre?.startDate;
                  delete pre?.endDate;
                  return { ...pre };
                });
              } else {
                setFilters((pre) => ({ ...pre, startDate, endDate }));
              }
            }}
          />
        ),
      }),
    },
    {
      _id: "oraganization",
      name: "Organization",
      align: "left",
      ...tableFilter({
        filterKey: "organization",
        filters,
        setFilters: (val) => {
          setFilters((pre) => ({ ...pre, ...val }));
        },
        filterList: organizationData?.data?.map((item) => ({
          name: `${lngDetect(item?.name)}`,
          value: item?._id,
          type: "checkbox",
        })),
      }),
    },
    // {
    //   _id: 4,
    //   name: "location Status",
    //   align: "left",
    //   ...tableFilter({
    //     filterKey: "locationStatus",
    //     filters,
    //     setFilters: (val) => {
    //       setFilters((pre) => ({ ...pre, ...val }));
    //     },
    //     filterList: [
    //       { name: "online", value: "online", type: "checkbox" },
    //       { name: "offline", value: "offline", type: "checkbox" },
    //       { name: "notspecified", value: "notspecified", type: "checkbox" },
    //     ],
    //   }),
    // },
    {
      _id: "visibility",
      name: "visibility",
      align: "left",
      ...tableFilter({
        filterKey: "visibility",
        filters,
        setFilters: (val) => {
          setFilters((pre) => ({ ...pre, ...val }));
        },
        filterList: [
          { name: "public", value: "public", type: "checkbox" },
          { name: "private", value: "private", type: "checkbox" },
        ],
      }),
    },
    {
      _id: "status",
      name: "status",
      align: "left",
      ...tableFilter({
        filterKey: "status",
        filters,
        setFilters: (val) => {
          setFilters((pre) => ({ ...pre, ...val }));
        },
        filterList: [
          // { name: "pending", value: "pending", type: "checkbox" },
          { name: "active", value: "active", type: "checkbox" },
          // { name: "invited", value: "invited", type: "checkbox" },
          // { name: "deactivated", value: "deactivated", type: "checkbox" },
          // { name: "deleted", value: "deleted", type: "checkbox" },
          { name: "inactive", value: "inactive", type: "checkbox" },
        ],
      }),
    },
    // {
    //   _id: 3,
    //   name: "Created On",
    //   align: "left",
    // },
    {
      _id: 8,
      name: "Action",
      align: "left",
    },
  ];

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div className="flex items-center gap-2">
              <div className="flex items-start -space-x-4">
                <Indentification className={"shadow-lg"} type="square" size="2xl" image={item?.gallery && item?.gallery[0]?.url} />
              </div>
              <div className="!font-semibold">
                <div>{lngDetect(item?.title)}</div>
                <div className="font-normal text-text-secondary">{dayjs(item?.createdAt).format("dddd, MMMM D, YYYY [at] h:mm A") || "-"}</div>
              </div>
            </div>
          ),
        },
        {
          _id: 5,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.userData?.firstName || item?.userData?.lastName ? `${item?.userData?.firstName} ${item?.userData?.lastName}` : "-",
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.startDate ? dayjs(item?.startDate).format("MMM DD, YYYY") : "-",
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.organizationData?.name?lngDetect(item?.organizationData?.name) : "N/A",
        },

        // {
        //   _id: 4,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data: (
        //     <Badge
        //       label={item?.locationStatus}
        //       className={"capitalize"}
        //       type={item?.locationStatus === "online" ? "success" : "danger"}
        //     />
        //   ),
        // },
        {
          _id: "visibility",
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: <Badge label={item?.visibility} type={item?.visibility === "public" ? "success" : "danger"} />,
        },
        {
          _id: 6,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <button
              type="button"
              onClick={() => {
                statusChangeHandler({
                  status: item?.status === "active" ? "inactive" : "active",
                  id: item?._id,
                });
              }}
            >
              <Badge label={item?.status} className={"capitalize"} type={item?.status === "active" ? "success" : "danger"} />
            </button>
          ),
        },
        // {
        //   _id: 3,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data: dayjs(item?.createdAt).format("MMM DD, YYYY") || "-",
        // },
        {
          _id: 9,
          type: "action",
          align: "left",
          cellClass: "w-[5%]",
          actionData: [
            {
              _id: 9.1,
              name: t("Detalis"),
              icon: "fa-regular fa-circle-info",
              onClick: () => {
                setDetailModal({ isOpen: true, data: item });
              },
              standout: false,
            },
            // {
            //   _id: 9.2,
            //   name: t("Edit"),
            //   icon: "fa-regular fa-pen-to-square",
            //   onClick: () => {
            //     setModalOpen({ isOpen: true, data: item });
            //   },
            //   standout: false,
            // },
            // {
            //   _id: 9.2,
            //   name: t("Delete"),
            //   icon: "fa-regular fa-trash-can",
            //   standout: true,
            //   onClick: () => {
            //     setDeleteModal({
            //       isOpen: true,
            //       data: item,
            //     });
            //   },
            // },
          ],
        },
      ],
    };
  });

  // add or edit page =================>
  function pageManageResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.status === 201) {
        if (filters?.page === 1) {
          queryClient.setQueryData(["Event", filters, search], (state) => {
            if (state) {
              let stateData = JSON.parse(JSON.stringify(state?.data));
              stateData = [...stateData, res?.data];
              return { ...state, data: stateData };
            }
          });
          if (data?.metadata?.totalDocs > filters?.limit) {
            queryClient.invalidateQueries(["Event", filters, search]);
          }
        } else {
          setFilters((pre) => ({ ...pre, page: 1 }));
        }
      }
      if (res?.status === 200) {
        queryClient.setQueryData(["Event", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = stateData?.map((item) => (item?._id === res?.data?._id ? { ...item, ...res?.data } : item));
            return { ...state, data: stateData };
          }
        });
        if (data?.metadata?.totalDocs > filters?.limit) {
          queryClient.invalidateQueries(["Event", filters, search]);
        }
      }
      setModalOpen({ isOpen: false, data: null });
    } else {
      toast.warning(res?.message || res?.error);
    }
  }

  //   Event delete handler =================>
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await eventDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return {
        res,
        payload: Array.isArray(payload) ? payload : [payload],
      };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        queryClient.setQueryData(["Event", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = stateData?.filter((item) => !payload?.includes(item?._id));

            return { ...state, data: stateData };
          }
        });

        if (data?.metadata?.totalDocs > filters?.limit) {
          queryClient.invalidateQueries(["Event", filters, search]);
        }
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const options = [
    {
      id: "userDelete",
      icon: "fa-regular fa-trash-can",
      tooltip: "User Delete",
    },
  ];

  function actionHandler(val) {
    switch (val) {
      case "userDelete":
        setDeleteModal({
          isOpen: true,
          data: { _id: selectedItems },
        });
        break;

      default:
        break;
    }
  }

  const { mutate: handleOrdering, isPending } = useMutation({
    mutationFn: async ({ newData, oldData }) => {
      const res = await eventOrdering({
        ordering_data: newData?.map((item, i) => ({
          id: item?._id,
          ordering: i,
        })),
      });
      return { res, newData, oldData };
    },
    onSuccess: ({ res, newData, oldData }) => {
      if (res?.status !== 200) {
        queryClient.setQueryData(["Event", filters, search], (state) => {
          if (state) {
            return { ...state, data: oldData };
          }
        });
        toast.warning(res?.message || res?.error);
      }
    },
  });

  return (
    <div className="w-full flex flex-col pb-10 bg-white rounded-md">
      <div className="space-y-8 py-8 px-5">
        <div className="flex items-center justify-between border-b border-gray-300">
          <div className="flex flex-col gap-2 w-full">
            <div className="font-bold text-lg xl:text-2xl tracking-tighter uppercase text-slate-900 font-Montserrat">Event Management</div>
            <div className="font-normal text-text-secondary h-10">
              Easily handle all event actions: update event info, location, status, and add new event data.
            </div>
          </div>
          {/* <div className="relative">
            <Button
              buttonClasses={
                "!bg-transparent border border-transparent !h-10 hover:!bg-primary/10 hover:!border-primary/10"
              }
              buttonLabel={"Create Event"}
              buttonLabelClasses={"font-medium !text-sm text-primary uppercase"}
              buttonHasLink
              buttonFunction={() => setModalOpen({ isOpen: true, data: null })}
              variant="secondary"
            />
          </div> */}
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-36">
              <LimitSelect
                value={filters?.limit}
                allValue={data?.metadata?.totalDocs}
                onChange={(val) => handleFilterChange("limit", val, setFilters)}
              />
            </div>
            <div className="w-72">
              <Search
                placeholder={"Search here"}
                search={(val) => {
                  setKeyword(val);
                  handleFilterChange("page", 1, setFilters);
                }}
              />
            </div>
            {selectedItems?.length > 0 && (
              <div className="flex items-center gap-2">
                <ActionBar options={options} onChange={actionHandler} />
                <span className="flex items-center rounded-full bg-secondary text-surface-01 text-xs px-3 py-1 gap-2">
                  {selectedItems?.length} Selected
                  <button onClick={() => setSelectedItems([])} type="button" className="cursor-pointer">
                    <i className="fa-fw fa-light fa-xmark"></i>
                  </button>
                </span>
              </div>
            )}
          </div>
          {/* <div className="flex items-center gap-3">
            <div className="relative">
              <Select
                selectedValue={"Buyer"}
                dropdownData={[{ name: "Buyer", value: "Buyer" }]}
                // onChange={(val) => {
                //   console.log({ val });
                //   handleChange({ target: { name: "parent", value: val } });
                // }}
                // onScroll={(e) => {
                //   loadData(e, categories, setCategoryilters);
                // }}
              />
            </div>
            <div className="relative">
              <Select
                selectedValue={"Past 3 month"}
                dropdownData={[{ name: "Past 3 month", value: "Past 3 month" }]}
                // onChange={(val) => {
                //   console.log({ val });
                //   handleChange({ target: { name: "parent", value: val } });
                // }}
                // onScroll={(e) => {
                //   loadData(e, categories, setCategoryilters);
                // }}
              />
            </div>
          </div> */}
        </div>
        <Table
          tableHeadData={tableHeadData}
          tableData={tableData}
          isLoder={isLoading}
          pageCount={data?.metadata?.totalPages}
          currentPage={filters?.page}
          onPageChange={(val) => {
            handleFilterChange("page", val, setFilters);
            setSelectedItems([]);
          }}
          originalData={[...(data?.data || [])]}
          setOriginalData={(val) => {
            queryClient.setQueryData(["Event", filters, search], (state) => {
              if (state) {
                return { ...state, data: val };
              }
            });
          }}
          handleOrdering={(newData, oldData) => handleOrdering({ newData, oldData })}
          isOrderingDisabled={false}
          isFetching={isFetching}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          tableActionDropdownContainer={"!w-48"}
        />
      </div>
      <ManageEventDrawer
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={pageManageResponse}
      />
      <EventDetailsDrawer
        open={detailModal?.isOpen}
        data={detailModal?.data}
        close={() => setDetailModal({ isOpen: false, data: null })}
        getResponse={pageManageResponse}
      />
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      />
    </div>
  );
};

export default Event;
